<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {
    traceAuth
} from '@/utils/auth'
export default {
  name: 'App',
  data() {
    return {
      network: true
    }
  },
  mounted() {
    this.$router.beforeEach((to, from, next) => {
      next()
      if (to.name === "login") {
        setTimeout(()=> {
          location.reload()
        },500)
      }
    })
    window.addEventListener("offline", () => {
        // 闪断不等于登录失效：这里只标记网络状态，不清登录态也不跳登录页，
        // 网络恢复后信令层会自动重连；真正到期的登录态仍由 request 层按原逻辑处理
        traceAuth('浏览器触发offline事件（仅标记网络状态，未登出）')
        this.network = false;
    });
    window.addEventListener("online", () => {
        this.network = true;
    });
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

html, body, #app {
  height: 100%;
  background:
    radial-gradient(ellipse at 15% 30%, rgba(0, 60, 180, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse at 85% 70%, rgba(0, 200, 255, 0.08) 0%, transparent 40%),
    radial-gradient(ellipse at 50% 0%, rgba(0, 100, 200, 0.12) 0%, transparent 50%),
    radial-gradient(ellipse at 50% 100%, rgba(0, 8, 50, 0.9) 0%, transparent 60%),
    linear-gradient(180deg, #000814 0%, #000c24 30%, #001030 60%, #000818 100%);
  background-attachment: fixed;
}

#app {
  font-family: 'Rajdhani', 'Orbitron', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #e0f0ff;
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue